let PaymentStatus = {
  BANK_TICKET: { NOT_ISSUED: {id: 0, name: 'Nao emitido'} },
  CREDIT_CARD: { },
};

export default PaymentStatus;
export const paymentStatuses = Object.keys(PaymentStatus).map(key => PaymentStatus[key]);


// WEBPACK FOOTER //
// ./src/enums/PaymentStatus.js